// 通用请求头
export const ContentTypeEnum = {
  Json: 'application/json;charset=UTF-8',
  FormURLEncoded: 'application/x-www-form-urlencoded;charset=UTF-8',
  FormData: 'multipart/form-data;charset=UTF-8',
} as const
